import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithOnlineCourse from '../../app/baseQueryWithOnlineCourse'
import {
    RatingListState,
    StudentRatingState,
    StudentWeekReportState,
    StudentWeekScoreState,
} from '../types'

interface ratingParams {
    groupId?: number
    courseSubjectId?: number
    monthNumber?: number
    weekNumber?: number
    filter?: string
    page: number
    size: number
}

export const ratingApiSlice = createApi({
    reducerPath: 'ratingApi',
    baseQuery: baseQueryWithOnlineCourse,
    tagTypes: ['Rating', 'Report'],
    endpoints: (build) => ({
        getStudentRating: build.query<RatingListState, ratingParams>({
            query: (params) => ({
                url: 'rating/students',
                params,
            }),
            providesTags: [{ type: 'Rating', id: 'LIST' }],
            transformResponse: (response: { data: any }) => ({
                data: response.data.data as StudentRatingState[],
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
                maxPoint: response.data.maxPoint,
                averagePoint: response.data.averagePoint,
            }),
        }),

        saveWeekScore: build.mutation<StudentWeekScoreState, StudentWeekScoreState>({
            query: (body) => ({
                url: 'rating/week-score',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Rating', id: 'LIST' },
                { type: 'Report', id: arg.userSubjectEnrollId },
            ],
            transformResponse: (response: any) => response.data,
        }),

        getWeekReport: build.query<
            StudentWeekReportState,
            { userSubjectEnrollId: number; monthNumber?: number; weekNumber?: number }
        >({
            query: ({ userSubjectEnrollId, monthNumber, weekNumber }) => ({
                url: `rating/report/${userSubjectEnrollId}`,
                params: { monthNumber, weekNumber },
            }),
            providesTags: (result, error, arg) => [
                { type: 'Report', id: arg.userSubjectEnrollId },
            ],
            transformResponse: (response: any) => response.data,
        }),
    }),
})
